import { useUserStore } from '@/store/UserStore'
import { Navigate, Outlet, useNavigate } from '@tanstack/react-router'
import { DashboardSidebar } from './sidebar'
import { Header } from './header'
import { useIsValidOrg } from '@/hooks/useIsValidOrg'
import { toast } from 'react-hot-toast'
import { SidebarProvider } from '@/components/ui/sidebar'
import { useActiveOrgId } from '@/hooks/useActiveOrgId'
import { LoadingMessage } from '@/components/loading-message'
import { AppBanner } from '@/components/app-banner'
import { CreateFirstServerPrompt } from '@/components/create-first-server-prompt'

export const Dashboard = () => {
  const { token } = useUserStore((state) => ({ token: state.user?.token }))
  const { orgId } = useActiveOrgId()
  const navigate = useNavigate()

  const { isLoading } = useIsValidOrg({
    orgId: Number(orgId),
    onInvalidOrgId: () => {
      toast.error('Org not found with the given id!')
      navigate({ to: '/404' })
    },
  })
  if (!token) {
    return <Navigate to="/login" />
  }

  if (isLoading) {
    return (
      <>
        <AppBanner />

        <div className="flex items-center justify-center h-screen">
          <LoadingMessage message="Loading dashboard..." centered />
        </div>
      </>
    )
  }

  return (
    <SidebarProvider className="flex min-h-screen w-full bg-background">
      <DashboardSidebar />

      <div className="flex-1">
        <AppBanner />

        <div className="p-4">
          <Header />
          <CreateFirstServerPrompt />
          <div className="p-4">
            <Outlet />
          </div>
        </div>
      </div>
    </SidebarProvider>
  )
}
